import React from 'react';
import { useField } from 'formik';
import { InputSwitch, InputSwitchProps } from 'primereact/inputswitch';
import {Checkbox as PrimeCheckbox, CheckboxProps } from 'primereact/checkbox';
import classNames from 'classnames';
import { ToggleButton, ToggleButtonProps } from 'primereact/togglebutton';
import {FormPageFieldComponentDefaultProps, FormPageFieldComponentProps} from 'types/formPage';
import cls from './airtable-fields.module.scss';
import {wrapComponent, extract, wrapArray,toBool} from "../utils";
import {withFormikFormControl} from "../FormikFormControl";
import { SelectButton } from 'primereact/selectbutton';
import _ from 'lodash';
import {BaseSelect} from "../SelectOptions/BaseSelect";

export const Checkbox = (props: (ToggleButtonProps | InputSwitchProps | CheckboxProps) & FormPageFieldComponentProps ) => {
    const { value, extraConfig, labelWrapperClassName, ...restProps } = props
  const { onLabel = 'ON', offLabel = 'OFF', display_as = 'select'} = extraConfig || {}
    const labelText = value && onLabel ? onLabel : ( !value && offLabel ? offLabel : '')
    const label = labelText ? <label htmlFor={restProps.name} className={classNames('p-checkbox-label')} style={{
        verticalAlign: 'top',
            marginLeft: '10px',
    }}>{labelText}</label> : ''
  let comp = null
  let useValue = [null,undefined].includes(value) ? value : toBool(value)
  if( display_as === 'checkbox' ){
      comp =(
          <div className={"col-12"}>
    <PrimeCheckbox onChange={(e) => {
        restProps.onBlur(e);
        restProps.onChange(e);
    }}
      checked={useValue}
      {...extract( {}, extraConfig, restProps)}
    />
              {label}
          </div>
              )
  }else if( display_as === 'switch') {
      const {inverse = false} = extraConfig
      comp = (<div>
          <InputSwitch
              onChange={(e) => {
                  restProps.onBlur(e);
                  restProps.onChange(e);
              }}
              checked={useValue}
              {...extract( {trueValue: !inverse, falseValue: inverse }, extraConfig, restProps)}
          />
          {label}
      </div> )
  }else if(display_as === 'button'){
      comp = (
          <ToggleButton
              checked={useValue}
              {...extract( { onLabel, offLabel, onIcon:"pi pi-check", offIcon: "pi pi-times", iconPos: undefined}, extraConfig, restProps)}
          />
      )
  }else if(['radio'].includes(display_as)) {
      const choices = [{
              name: onLabel,
              icon: _.get(extraConfig, 'onIcon', 'pi pi-check'),
              value: true
          },
          {
              name: offLabel,
              icon: _.get(extraConfig, 'offIcon', 'pi pi-times'),
              value: false
          }]

      comp = (
          <BaseSelect multiple={false} compOnly={true} {...{...props, extraConfig: {...extraConfig, keyValue:'value', options:{choices}}}}/>
      )
  }else if(['select'].includes(display_as)){
      const offFirst = _.get(extraConfig, 'offFirst', false)
      const itemTemplate = (option) => <><i className={option.icon}></i><span style={{marginLeft: '15px'}}>{option.name}</span></>;
       const {multiple=false} = extraConfig
      const options = [
          {
              name: onLabel,
              icon: _.get(extraConfig, 'onIcon', 'pi pi-check'),
              value: true
          },
          {
              name: offLabel,
              icon: _.get(extraConfig, 'offIcon', 'pi pi-times'),
              value: false
          }

      ]
      comp = (
          <SelectButton value={multiple ? wrapArray(useValue) : useValue} optionLabel="name" optionValue="value" options={offFirst ? options.reverse() : options}  itemTemplate={itemTemplate}
                        {...extract( { multiple: undefined}, extraConfig, restProps)}

          />

      )
  }

  return wrapComponent( comp, extraConfig )
};



export const CheckboxFormik = withFormikFormControl()(Checkbox);
export default CheckboxFormik;
